import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { RxdbService } from './rxdb.service';
import { StorageService } from './storage.service';
import { tap, catchError } from 'rxjs/operators';
import { of, Observable, BehaviorSubject } from 'rxjs';
import { catchOffline } from '@ngx-pwa/offline';


@Injectable({
  providedIn: 'root'
})
export class ApiService {
  private showHideSideNav: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  showHideSideNavObs = this.showHideSideNav.asObservable();
  private selectedAssessmentBehavior: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  selectedAssessmentObs = this.selectedAssessmentBehavior.asObservable();
  private assessmentStandAlonedata: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  assessmentStandAlonedataObs = this.assessmentStandAlonedata.asObservable();
  accessToken: string;
  headers: any;
  constructor(private http: HttpClient, private rxDB: RxdbService, private storage: StorageService) {
    this.accessToken = storage.getLocalValue('authSession', 'json');
    this.headers = {
      headers: new HttpHeaders(
        {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${this.accessToken}`,
          'Access-Control-Allow-Origin': '*'
        }
      )
    };
  }

  getReportList() {
    const getUrl = '/gcmicroapi/api/aps/assigned';
    return this.http.get(getUrl, this.headers).pipe(
      catchOffline(),
      tap(data => data),
      catchError(error => {
        console.error(error);
        return of(error);
      })
    );
  }

  getSchema(schema: string) {
    return this.http.get(`./assets/apsData.json`).pipe(catchOffline());
  }

  getValues(apsReportLoadId: number) {
    const getUrl = `/gcmicroapi/api/aps/${apsReportLoadId}`;
    return this.http.get(getUrl, this.headers).pipe(
      catchOffline(),
      tap(data => data),
      catchError(error => {
        console.error(error);
        return of(error);
      })
    );
  }

  saveAndComplete(apsData: any) {
    return this.http.put<any>('/gcmicroapi/api/aps/updateApsFull', apsData, this.headers).pipe(
      catchOffline(),
      tap((data: any) => {
        return data;
      }),
      catchError((error: any): Observable<any> => {
        console.error(error);
        return of(error);
      })
    );
  }

  getOptions() {
    return this.http.get('./assets/apsOptions.json');
  }

  sideNavBehavior(value: boolean) {
    this.showHideSideNav.next(value);
    return this.showHideSideNav;
  }

  setSelectedAssessmentOnAdd(value: any) {
    this.selectedAssessmentBehavior.next(value);
  }

  getSelectedAssessment() {
    return this.selectedAssessmentBehavior;
  }

  setAssessmentStandAlonedata(value: any) {
    this.assessmentStandAlonedata.next(value);
  }

  getAssessmentStandAlonedata() {
    return this.assessmentStandAlonedata;
  }

  removeFromCheckoutList(apsReportLoadId: number) {
    const getUrl = `/gcmicroapi/api/aps/release/${apsReportLoadId}`;
    return this.http.get(getUrl, this.headers).pipe(
      catchOffline(),
      tap(data => data),
      catchError(error => {
        console.error(error);
        return of(error);
      })
    );
  }
}
